import { signal, Signal } from '@preact/signals'
import { DataCaptureContext, FrameSourceState, SingleImageUploader } from '@scandit/web-datacapture-core'
import type AppStore from './AppStore'

export type TSingleImageModeStore = {
  enable: () => Promise<void>
  enabled: Signal<boolean>
}

const SingleImageModeStore = (appStore: AppStore): TSingleImageModeStore => {
  const enabled = signal(false)
  return {
    async enable() {
      await DataCaptureContext.sharedInstance.setFrameSource(SingleImageUploader.default)
      await DataCaptureContext.sharedInstance.frameSource?.switchToDesiredState(FrameSourceState.On)
      await appStore.sdk!.barcodeCaptureMode?.setEnabled(true)
      enabled.value = true
    },
    enabled,
  }
}

export default SingleImageModeStore
